<template>
    <div class="customFormWrapper">
        <el-card class="box-card" v-for="(group,index) in groupList" :key="index" style="margin-bottom: 10px;">
            <div slot="header" class="clearfix">
                <span>{{group.title}}</span>
            </div>
            <!--  表单数据  -->
            <el-form  v-if="group.contentType==0"
                      label-width="200px" style="display: flex;flex-wrap: wrap;justify-content: space-between">
                  <el-form-item v-for="(cellItem,i) in group.dataList" v-if="cellItem.showInList"
                                :key="i"
                                :class="{
                                    'single-row':(cellItem.columnCount == '1' || cellItem.columnType  == '3' ),
                                    'double-row':(cellItem.columnCount == '2' && cellItem.columnType  != '3' ),
                                    'third-row':(cellItem.columnCount == '3' && cellItem.columnType  != '3'),
                                    'empty-label':( cellItem.textType == 0)}">
                                    <template slot="label">
                                    <span style="display:inline-block;width:174px">{{cellItem.title}}</span>
                                    <span style="display:inline-block;vertical-align: top;">：</span>
                                </template>
                    <div v-if="cellItem.columnType == '3'" v-html="cellItem.value" style="text-align: left"></div>

                    <span v-else-if="cellItem.columnType == '5' || cellItem.columnType == '6'" style="text-align: center">
                        <el-link v-if="cellItem.datasource.indexOf('http') > -1" type="primary" :underline="false" :href="baseUrlBase + cellItem.datasource?cellItem.datasource:''" target="_blank">{{cellItem.title}}</el-link>
                        <el-button
                                    v-else
                                :type="cellItem.columnType == '6'?'text':'primary'"
                                size="mini"
                                @click.stop="buttonClick(cellItem.datasource,cellItem.columnType)"
                                :underline="false">{{cellItem.title}}</el-button>
                    </span>

                    <span v-else>
                        <div v-if="!cellItem.isWarn" style="display: inline-block; word-break: break-all;" v-html="formatChangeColor(cellItem)">
                        </div>
                        <span v-else>
                            <div class="warning-box">{{cellItem.value}}</div>

                            <el-popover
                                    placement="top"
                                    width="350"
                                    title="预警说明"
                                    trigger="click">
                                  <p style="padding:0px 16px 12px 12px;margin: 0">
                                       <el-form label-width="84px" style="display: flex;flex-wrap: wrap;justify-content: space-between" class="viewFormWrapper">
                                           <el-form-item label="预警项：">
                                                <span class="activeColor">{{cellItem.warnItemsName }}</span>
                                            </el-form-item>
                                           <el-form-item label="预警说明：">
                                                <span class="activeColor">{{cellItem.warnItemsContent }}</span>
                                            </el-form-item>
                                       </el-form>
                                  </p>
                                  <div style="text-align: center; margin: 0;padding: 12px">
                                       <el-button type="primary" size="mini" @click="routerToDetail(cellItem.warnItemsDetailId)">查看详情</el-button>
                                  </div>
                                  <icon-svg name="tishi" slot="reference" :width="'18px'" :height="'18px'" class="site-sidebar__menu-icon"></icon-svg>
                             </el-popover>

                        </span>
                    </span>
                  </el-form-item>
            </el-form>
            <!--  表格数据  -->
            <div v-else-if="group.contentType==1 && group.fieldList.length > 0">
                <div v-if="group.queryParamList.length > 0">
                    <el-form  class="form viewFormWrapper" :inline="true">
                        <el-form-item :label="item.displayName+'：'" class="searchInForm" v-for="(item, index) in group.queryParamList" :key="index">
                            <el-input v-model="searchForm[item.paramsName]" placeholder="请输入内容"></el-input>
                        </el-form-item>
                        <el-button size="small" type="primary" style="margin-left:30px;" @click="getCustomDataDetail('searchList',group.groupId)">搜索</el-button>
                        <el-button plain size="small" type="primary" style="margin-left:10px;"  @click.prevent="getCustomDataDetail('searchList',0)">重置</el-button>
                    </el-form>
                </div>

                <!-- <table class="customFormTable">
                    <thead>
                        <th v-for="item in group.fieldList" :key="item.id" v-if="item.showInList && item.columnName == 'id'" width="50">操作</th>
                        <th v-for="item in group.fieldList" :key="item.id" v-if="item.showInList && item.columnName != 'id'" :width="item.columnWidth?item.columnWidth:'auto'">{{item.displayName}}</th>
                    </thead>
                    <tbody>
                        <tr v-for="(item,index) in group.rowList" :key="index">
                            <template v-for="itm in group.fieldList">
                                <template v-for="(value, key) in item">
                                    <td v-if="itm.columnName == key && itm.showInList && key == 'id' && item.id" width="50">
                                        <el-button type="text" title="查看" @click="getCustomDataDetail(item.id, null)">查看</el-button>
                                    </td>
                                    <td v-if="itm.columnName == key && itm.showInList && key != 'id'" :width="item.columnWidth?item.columnWidth:'auto'">{{itm.columnName== 'sort'?(index+1):value}}</td>
                                </template>
                            </template>
                        </tr>
                        <tr v-if="group.rowList.length == 0" >
                            <td :colspan="group.fieldList.length">暂无数据</td>
                        </tr>
                        <tr v-if="group.isMore">
                          <td :colspan="group.fieldList.length"  >
                            <span class="link" @click="loadMore(group.groupId)">点击加载更多...</span>
                          </td>
                        </tr>
                    </tbody>
                </table> -->
                <!-- 用el-table实现上面的表格 -->
                <el-table v-if="group.rowList.length > 0" :data="group.rowList" border stripe style="width: 100%">
                    <el-table-column v-for="item in group.fieldList" :key="item.id"  :label="item.displayName" :prop="item.columnName" :width="item.columnWidth?item.columnWidth:'auto'">
                        <template slot-scope="scope">
                            <span v-if="item.columnName == item.key && itm.showInList && item.key == 'id' && item.id">
                                <el-button type="text" title="查看" @click="getCustomDataDetail(scope.row.id, null)">查看</el-button>
                            </span>
                            <span v-else-if="item.columnName == 'file_path_download'">
                                <a v-if="scope.row[item.columnName]" @click="downloadFile(scope.row,item.columnName)">下载</a>
                                <span v-else>未解密</span>
                            </span>
                            <span v-else>{{scope.row[item.columnName]}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <div v-if="group.rowList.length == 0" style="text-align: center;margin-top: 20px;">暂无数据</div>
                <div v-if="group.isMore" style="text-align: center;margin-top: 20px; text-decoration: none;">
                    <span class="link" @click="loadMore(group.groupId)">点击加载更多...</span>
                </div>
            </div>
            <!--  表单集合  -->
            <div v-else-if="group.contentType==2 && group.collList.length > 0">
              <el-form v-for="(item, index) in group.collList" :key="index" label-width="200px" style="display: flex;flex-wrap: wrap;justify-content: space-between">
                <el-divider v-if="index != 0"></el-divider>
                <el-form-item :label="cellItem.title+''"
                              v-for="(cellItem,i) in item"
                              v-if="cellItem.showInList"
                              :key="i"
                              :class="{'single-row':cellItem.columnCount == '1' || cellItem.columnType  == '3' }">
                                <template slot="label">
                                    <span style="display:inline-block;width:174px">{{cellItem.title}}</span>
                                    <span style="display:inline-block;vertical-align: top;">：</span>
                                </template>
                  <div v-if="!cellItem.isWarn" style="display: inline-block;">
                    {{cellItem.value}}
                  </div>
                  <span v-else>
                      <div class="warning-box">{{cellItem.value}}</div>
                      <el-popover
                         placement="top"
                         width="350"
                         title="预警说明"
                         trigger="click">
                              <p style="padding:0px 16px 12px 12px;margin: 0">
                                   <el-form label-width="84px" style="display: flex;flex-wrap: wrap;justify-content: space-between" class="viewFormWrapper">
                                       <el-form-item label="预警项：">
                                            <span class="activeColor">{{cellItem.warnItemsName }}</span>
                                        </el-form-item>
                                       <el-form-item label="预警说明：">
                                            <span class="activeColor">{{cellItem.warnItemsContent }}</span>
                                        </el-form-item>
                                   </el-form>
                              </p>
                              <div style="text-align: center; margin: 0;padding: 12px">
                                   <el-button type="primary" size="mini" @click="routerToDetail(cellItem.warnItemsDetailId)">查看详情</el-button>
                              </div>
                              <icon-svg name="tishi" slot="reference" :width="'18px'" :height="'18px'" class="site-sidebar__menu-icon"></icon-svg>
                         </el-popover>
                  </span>
                </el-form-item>
              </el-form>
            </div>
            <p  v-if="(group.contentType==0 && group.dataList.length == 0)||(group.contentType==1 && group.fieldList.length == 0) || (group.contentType==2 && group.collList.length == 0)" style="text-align: center">暂无数据</p>

        </el-card>

        <el-card class="box-card" v-if="groupList.length == 0" style="height: 700px;position: relative;margin-bottom: 10px;" >
            <emptyInfo v-if="groupList.length == 0" :emptyMsg="'暂无表单数据'" ></emptyInfo>
        </el-card>
        <!-- 附件数据 -->
        <el-card class="box-card" v-if="formInfo.hasAttach != undefined && formInfo.hasAttach != ''">
            <div slot="header" class="clearfix">
                <span>附件列表</span>
                <!-- <div @click="refreshFn" v-if="IsShow(item)&&filingCBtn" class="refresh">刷新</div> -->
            </div>


            <template>
                <div class="affixDown" v-if="attachmentList.length > 0"  style="margin-bottom: 10px" v-loading="refreshLoading">
                    <affix-doc v-for="(item,index) in attachmentList"
                               :item.sync="item"
                               labelWidth="200px"
                               :index="index"
                               :key="index"
                               @refreshPdf="refreshFn"
                               :entityId="entityId"
                               :filingCBtn="IsShow(item)&&filingCBtn"
                               @updateItem="updateItem"
                               @updateFileList="updateFileList"
                               :showModal="false"
                               :name="item.titleName">
                    </affix-doc>
                </div>
                <p style="text-align: center" v-if="attachmentList.length == 0">暂无附件数据</p>
            </template>
        </el-card>
        <!-- 监督记录 -->
        <el-card class="box-card" style="margin-bottom:10px" v-if="auditHisTableCopy && auditHisTableCopy.length > 0">
            <div slot="header" class="clearfix">
                <span>工作流</span>
            </div>
            <el-table
                    :data="auditHisTableCopy"
                    stripe
                    border
                    style="width: 100%;">
                <el-table-column
                        type="index"
                        header-align="center"
                        align="center"
                        label="序号"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="taskName"
                        align="left"
                        :show-overflow-tooltip="true"
                        width="200"
                        label="步骤"  >
                </el-table-column>
                <el-table-column
                        prop="auditorName"
                        align="left"
                        :show-overflow-tooltip="true"
                        width="250"
                        label="办理人员"  >
                </el-table-column>
                <el-table-column
                        prop="endTime"
                        align="center"
                        width="250"
                        label="处理时间">
                    <template slot-scope="scope">
                        <span>{{formatDate(scope.row.endTime,'yyyy-MM-dd HH:mm:ss')}}</span>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="auditMsg"
                        align="left"
                        :show-overflow-tooltip="true"
                        label="描述/意见">
                </el-table-column>
            </el-table>
        </el-card>


    </div>
</template>

<script>
    import affixDoc from '@/components/affixDoc';
    import emptyInfo from '@/components/empty-info';
    import {removeTabHandle} from '@/utils/routeTab';

    export default {
        components: {
            affixDoc,
            emptyInfo
        },
        props:{
            nodeCode:{
                type:String,
                defalut:'GC00014'
            },
            // 监督记录列表数据
            auditHisTable:{
                type:Array,
                default:()=>([])
            },
            // 视角
            angleType:{
                type:Number,
                default:0
            },
            // 查询附件所需参数
            entityId:{
                type:String,
                default:""
            },
            // 查询附件所需参数
            categoryCode:{
                type:String,
                default:""
            },
            filingCBtn:{
                type:Boolean,
                defalut:false
            },
        },
        watch:{
            auditHisTable: {
                immediate: true,
                handler (val) {
                    this.auditHisTableCopy = val
                },
                // 这里是关键，代表递归监听 demo 的变化
                deep: true
            },
            nodeCode:{
                immediate: true,
                handler (val) {
                    this.nodeCodeCopy = val
                },
                deep: true
            },
        },
        data() {
            return {
                refreshLoading:false,
                groupList: [],
                paramMap:{},
                baseUrlBase:'',
                nodeCodeCopy:"",
                auditHisTableCopy:[],
                attachmentList:[],
                visible:false,
                // 查询附件所需参数
                entityIdCopy:"",
                // 查询附件所需参数
                categoryCodeCopy:"",
                formInfo:{
                  hasAttach:false,
                },
                itemList:[],
                searchForm:{},
                tableData: [{
                    date: '2016-05-02',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1518 弄'
                }, {
                    date: '2016-05-04',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1517 弄'
                }, {
                    date: '2016-05-01',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1519 弄'
                }, {
                    date: '2016-05-03',
                    name: '王小虎',
                    address: '上海市普陀区金沙江路 1516 弄'
                }],

                changeColorNode: process.env.NODE_ENV !== 'production' ? 'GC00057' : 'GC00054',
                changeColorArray: [],
            }
        },
        created() {

            // this.baseUrlBase = baseUrl
            // console.log('baseUrlBase1111111',this.baseUrlBase)
        },
        activated() {
            // this.baseUrlBase = baseUrl
            // console.log('baseUrlBase11221',this.baseUrlBase)

        },
        mounted() {
            // this.baseUrlBase = baseUrl
            // console.log('baseUrlBase11689541',this.baseUrlBase)
        },
        methods: {
            getChangeColorArray(){
                this.$http.get(`/fieldApply/jzTrading/getChangeFieldList?tenderProjectCode=${this.paramMap.tenderProjectCode}&entityId=${this.paramMap.entityId}`).then(res=>{
                    if(res.data.code==='1'){
                        this.changeColorArray = res.data.data;
                    }else{
                        this.changeColorArray = [];
                        this.$message({
                            type:'error',
                            message:res.data.msg
                        })
                    }
                })
            },
            formatChangeColor(cellItem){
                if(this.nodeCodeCopy == this.changeColorNode && this.changeColorArray.indexOf(cellItem.columnName)>-1){
                    return "<div style='background: rgb(246,154,35);'>"+cellItem.value+'</div>'
                }else{
                    return cellItem.value;
                }
            },
            updateItem(index, filePath){
                console.log('updateItem',index,filePath)
                const item = this.attachmentList[index]
                this.$set(this.attachmentList, index, { ...item, filePath: filePath})
            },
            updateFileList() {
                this.getAttachments();
            },
            GetRequest(href) {
                var url = href.substring(href.indexOf("?")); //获取url中"?"符后的字串
                var theRequest = new Object();
                if (url.indexOf("?") != -1) {
                    var str = url.substr(1);
                    var strs = str.split("&");
                    for(var i = 0; i < strs.length; i ++) {
                        theRequest[strs[i].split("=")[0]]=decodeURI(strs[i].split("=")[1]);
                    }
                }
                return theRequest;
            },
            buttonClick(src,type){
                // type ==5 按钮，type ==6 链接
                let params = this.GetRequest(src)
                var getBase = src.indexOf("?")>-1?src.substring(0,src.indexOf("?")+1):null;
                for(var i in params){
                    let value = params[i];
                    let variable = value.indexOf('${') > -1;
                    if(value.indexOf('${') > -1 || value.indexOf('}') > -1){
                        value = value.replace('${','') ;
                        value = value.replace('}','') ;
                    }
                    getBase += `&${i}=${variable?this.paramMap[value]:value}`
                }

                let srcReq = getBase.replace('?&','?');
                if(type == '6'){ // type ==6 链接

                    this.$router.push({
                        path: srcReq,
                    });

                }else{

                    this.$http.get(srcReq).then(res => {
                        if (res.data.code === '1') {
                            window.open(res.data.data,'_target')

                        }else{
                            this.$message.error(res.data.msg)
                        }
                    })
                }



            },
            //招标文件澄清与修改及资审文件澄清与修改 记录列表 查看详情方法
            getCustomDataDetail(id,groupId){
                this.getCustomData(this.formId,this.paramMap,false,id, groupId);
            },

            // 获取监督记录
            async getAuditHisList(entityId){
                // 查询监督记录数据
                if(entityId){
                    this.$http.get('/auditHistory/getListAudit?entityId='+entityId).then(res=>{
                        if(res.data.code==='1'){
                            this.auditHisTableCopy = res.data.data;
                        }else{
                            this.auditHisTableCopy = [];
                            this.$message({
                                type:'error',
                                message:res.data.msg
                            })
                        }
                    })
                }else{
                    this.auditHisTableCopy = [];
                }

            },

            async getCustomData(formId,paramMap,getAttByEntityId,detailId, groupId){

                // 咸宁见证系统 查询自定义表单需要先查询 EntityId ，再 在customform/query/detail 接口里 传递 EntityId查询表单数据，
                // 故而此处抽出 customformQueryDetail 方法，用来查询到entityId 后 查询表单数据
                if(getAttByEntityId){
                    // 是否通过查询 EntityId 查询附件及审核信息数据 ，自定义表单内部表格点击事件不需要查询 EntityId，本身带有 entityId
                    this.$http.get(`/businessFlow/flowNodeWitness/getEntityId?projectCode=${paramMap.projectCode}&tenderProjectCode=${paramMap.tenderProjectCode}&bidSectionCode=${paramMap.bidSectionCode}&datasetCode=${paramMap.datasetCode}`).then(res=>{
                        if(res.data.code=='1'){
                            let responseId = res.data.data || '';
                            this.paramMap.entityId = responseId;
                            paramMap.entityId = responseId;
                        }else{
                            this.paramMap.entityId = '';
                            this.attachmentList = [];
                        }
                        this.customformQueryDetail(formId,paramMap,getAttByEntityId,detailId, groupId)

                    })
                }else{
                    if (detailId) {
                        this.paramMap.entityId = detailId
                    }
                    this.customformQueryDetail(formId,paramMap,getAttByEntityId,detailId, groupId)
                    if(this.nodeCodeCopy == this.changeColorNode){
                        this.getChangeColorArray();
                    }
                }

                // if(this.formInfo.hasAttach || this.paramMap.enableHandle){
                //     if(getAttByEntityId){
                //         this.$http.get(`/businessFlow/flowNodeWitness/getEntityId?projectCode=${paramMap.projectCode}&tenderProjectCode=${paramMap.tenderProjectCode}&bidSectionCode=${paramMap.bidSectionCode}&datasetCode=${paramMap.datasetCode}`).then(res=>{
                //             if(res.data.code=='1'){
                //                 let responseId = res.data.data || '';
                //                 if(this.formInfo.hasAttach)this.getAttachments(responseId,this.categoryCode)
                //                 if(this.paramMap.enableHandle)this.getAuditHisList(responseId)
                //                 this.customformQueryDetail(formId,paramMap,getAttByEntityId,detailId, groupId)
                //             }else{
                //                 this.attachmentList = [];
                //             }
                //         })
                //     }else{
                //         this.getAttachments()
                //         this.customformQueryDetail(formId,paramMap,getAttByEntityId,detailId, groupId)
                //     }
                // }

            },
            customformQueryDetail(formId,paramMap,getAttByEntityId,detailId, groupId){
                // formId=自定义表单id ,paramMap= 项目数据参数 ，getAttByEntityId = 是否通过查询 entityId 和 已传参数categoryCode 查询附件数据及监督记录数据，detailId =  招标文件澄清与修改及资审文件澄清与修改 查看详情数据的id
                this.formId = formId;
                const _this = this;
                if(detailId && detailId != 'searchList'){
                    paramMap.id = detailId;
                }
                this.paramMap = paramMap;

                if (groupId) {
                  this.itemList.forEach((item)=>{
                    if (item.groupId == groupId) {
                      detailId == 'searchList'?item.rows = 20:item.rows += 20;
                      for(var key in _this.searchForm){
                        if(key.toString().indexOf(item.groupId) > -1){
                          let val = _this.searchForm[key]
                          let column = key.split("-")[1]
                          item[column] = val;
                        }
                      }
                    }
                  })
                } else {
                    this.itemList = [];
                    for(var key in _this.searchForm){
                        // _this.searchForm[key] = ""
                        _this.$set(_this.searchForm,key,"")
                    }
                }
                // 优化接口参数
                paramMap.itemList = this.itemList;
                // 重新定义查询参数，避免污染全局 paramMap 对象
                let  paramsMapTemp = JSON.parse(JSON.stringify(paramMap || this.paramMap))
                paramsMapTemp.applyCode = paramsMapTemp.applyCode == '-1'?'':paramsMapTemp.applyCode;
                paramsMapTemp.idcard = paramsMapTemp.idcard == '-1'?'':paramsMapTemp.idcard;
                paramsMapTemp.id = paramsMapTemp.entityId || '';
                let businessType =  this.$route.query.businessType || "";
                if(businessType == 'CG'){ // 采购业务重写 查询参数
                    paramsMapTemp.purchaseProjectCode = paramsMapTemp.tenderProjectCode
                    paramsMapTemp.purchaseSectionCode = paramsMapTemp.bidSectionCode
                }
                // 重置附件及审核列表数据
                this.auditHisTableCopy = [];
                this.attachmentList = [];

                if(formId){
                    let url=this.$http.adornUrl(`/customform/query/detail/${formId}`)
                    this.$http
                        .post(url, paramsMapTemp,{baseURL:'',})
                        .then(({ data }) => {
                            if (JSON.stringify(data) != "{}") {
                                this.groupList = data.data;
                                let sign = this.itemList.length > 0 ? false : true;
                                this.groupList.forEach((item)=>{
                                  if (item.contentType == 1) {
                                    item.queryParamList && item.queryParamList.forEach((itm)=>{
                                      itm.paramsName = item.groupId + '-' + itm.columnName
                                    })
                                    if (sign) {
                                      let obj = {};
                                      obj.groupId = item.groupId;
                                      obj.datasetId = item.datasetId;
                                      obj.rows = 20;
                                      this.itemList.push(obj);
                                    }
                                    // item.isMore = item.rowList.length >= 20;
                                  }
                                });
                                this.formInfo=data.form;

                                // 是否通过查询 EntityId 查询附件及审核信息数据 ，自定义表单内部表格点击事件不需要查询 EntityId，本身带有 entityId
                                if(!getAttByEntityId && detailId){
                                    this.paramMap.entityId = detailId;
                                }
                                this.getAttachments(this.paramMap.entityId );
                                this.getAuditHisList(this.paramMap.entityId );
                            } else {
                                this.groupList = [];
                                this.formInfo={}
                            }
                        });

                }else{
                    this.groupList = [];
                    this.formInfo={};
                }
            },
            // 查询附件
            getAttachments(entityId){
                let entityIdParam = entityId || this.entityId || this.paramMap.entityId;
                console.log(this.formInfo.hasAttach,entityIdParam,this.categoryCode,this.entityId)
                if(this.formInfo.hasAttach && entityIdParam != '' && this.categoryCode != ''){

                    if(!this.paramMap.categoryIsOpen){  // 不支持附件类别约束
                        this.$http.get(`/attachment/getAttachmentByBizId?bizid=${entityIdParam}`).then(({ data }) => {
                            if (data.code == "1") {
                                this.attachmentList = data.data || [];
                                this.attachmentList.forEach((item)=>{
                                    item.titleName = '相关附件'
                                })
                            } else{
                                this.attachmentList = [];
                            }
                        });

                    }else{

                        this.$http.get(`/attachment/getDataByCodeAndEid?categoryCode=${this.categoryCode}&entityId=${entityIdParam}`).then(({ data }) => {
                            if (data.code == "1") {
                                let resData= data.data;
                                if(resData && resData.length > 0){
                                    resData.forEach(v => {
                                        v.titleName = v.name
                                    })
                                    // 判断评标结果只展示附件评标，在第一个  
                                    const datasetCodeFlag = this.$route.query.datasetCode == 'A34';
                                    if (datasetCodeFlag) {
                                        this.attachmentList = [resData[0]];
                                    }else{
                                        this.attachmentList = resData;
                                    }

                                    this.$emit('callAttachmentList', resData);
                                }else{
                                    this.attachmentList = [];
                                }
                            } else{
                                this.attachmentList = [];
                            }
                        });
                        // this.attachmentList =  [
                        //     {
                        //         "appId": "1d7358a453b14c0692860a04c561ebcc",
                        //         "attFiles": [
                        //             {
                        //                 "bizId": "03747cc69f0e400fbb2ef6cfb8d58240",
                        //                 "createDate": "2023-09-20 10:08:35",
                        //                 "delFlag": "1",
                        //                 "filePath": "/upload/eb5_jsgc_project_plan_att/7d3ba6d4b0d9b63d5ff8c4b4c190f79ccc4dc930e1ae95fc9af5c9505cd4ae92.pdf",
                        //                 "fileSize": 0,
                        //                 "fileType": "1",
                        //                 "hashCode": "",
                        //                 "id": "c0f6b1d380c3450196264288e3abd953",
                        //                 "name": "中标结果公告.pdf",
                        //                 "remark": "{comeform:GC}",
                        //                 "sort": 1,
                        //                 "updateDate": "2023-09-20 10:08:35"
                        //             },
                        //             {
                        //                 "bizId": "03747cc69f0e400fbb2ef6cfb8d58240",
                        //                 "createDate": "2023-09-20 10:08:35",
                        //                 "delFlag": "1",
                        //                 "filePath": "/upload/eb5_jsgc_project_plan_att/13b550b205a2e28e28976e8dc70bbc434982290b8ef44812dc2a90c0153bbcb3.pdf",
                        //                 "fileSize": 0,
                        //                 "fileType": "1",
                        //                 "hashCode": "",
                        //                 "id": "1a2ccde581b741e9890013da3217296f",
                        //                 "name": "测试 (1).pdf",
                        //                 "remark": "{comeform:GC}",
                        //                 "sort": 2,
                        //                 "updateDate": "2023-09-20 10:08:35"
                        //             }
                        //         ],
                        //         "attributes": {},
                        //         "categoryCode": "gc_project_plan_att",
                        //         "categoryId": "718f7d10bd204322bd07a2037c03e393",
                        //         "createTime": "2023-04-14 13:49:21",
                        //         "createUser": "system",
                        //         "delFlag": false,
                        //         "fileType": "1",
                        //         "id": "d60e6ff08f1f4d9585f25b85a4c34f57",
                        //         "titleName": "招标计划",
                        //         "required": false,
                        //         "showFlag": false,
                        //         "sort": 1,
                        //         "systemFlag": true,
                        //         "updateTime": "2023-08-15 18:52:03",
                        //         "updateUser": "system",
                        //         "upload": false,
                        //         "value": "1"
                        //     }
                        // ]
                    }

                }else{
                        this.attachmentList = [];
                }
                setTimeout(()=>{
                    this.refreshLoading=false;
                },500)
            },
            IsShow(item){
                var mark = item.attributes
                if(mark && mark.showSignBtn){
                    return true
                }
                return false

            },

            resetCustomData(){
                this.groupList = [];
                this.formInfo={}
            },
            routerToDetail(id){

                removeTabHandle('warn_record_detail')


                this.$router.push({
                    name: "warn_record_detail",
                    query: {
                        id:id || '',
                        angleType:this.angleType,
                    },
                });


            },

            showWarnItem(warnItemId, warnItemName, warnItemContent) {
              this.$confirm('预警项：'+warnItemName, '预警说明', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
              }).then(() => {
              }).catch(() => {
              });
            },
            loadMore(groupId) {
                this.getCustomDataDetail(null, groupId);
            },
            refreshFn(){//刷新文件数据
                this.refreshLoading=true;
                this.getAttachments()
            },

            downloadFile(item,name){
                this.$http.get(`/atta/getAttachmentByFilePath?filePath=${item[name]}`).then(({ data }) => {
                    if (data.code == "1") {
                        window.open(data.data)
                    }
                });
            }
        }
    }
</script>


<style lang="less" scoped>
    .el-card{
        border: none!important;
        margin-bottom: 24px !important;
    }
    /deep/ .el-table__header{
        width: 100% !important;
    }
    /deep/ .el-table__body{
        width: 100% !important;
    }
    .customFormWrapper{
        .el-dialog__wrapper /deep/ .el-dialog__header{
        }
        .el-dialog__wrapper /deep/ .el-dialog__body{
            padding: 10px 20px;
        }
        .el-form /deep/ .el-form-item.single-row{
            width: 100%;
        }
        .el-form /deep/ .el-form-item.double-row{
            width: 50%;
        }
        .el-form /deep/ .el-form-item.third-row{
            width: 33%;
        }
        .el-form /deep/ .el-form-item.empty-label{
            .el-form-item__label{
                display: none;
            }
          .el-form-item__content{
            margin-left: 0px !important;
          }
        }

        .el-form /deep/ .el-form-item{
            .el-form-item__label,.el-form-item__content{
                line-height: 26px;
            }
        }

        .el-form /deep/ .el-form-item{
            width: 50% ;
            margin-bottom:0px;
        }

        .el-form /deep/ .el-form-item.searchInForm{
            width:auto;
            margin-bottom: 10px;
            .el-form-item__label{
                line-height: 32px;
            }
        }

        .el-dialog__wrapper /deep/ .el-dialog__footer{
            display: flex;
            align-items: center;
            justify-content: center;
        }
        .link:hover {
            cursor: pointer; //鼠标变手
            /*background-color: #1890FF; //链接变颜色*/
            /*color: white!important;*/
        }
        .warning-box{
            display: inline-block;background: #ffc7ce;color: #ff0000;line-height: 22px
        }

        .customFormTable {
            width: 100%;
            padding: 0;
            margin: 0;
            border: 1px solid #ebeef5;
            border-spacing: 0;
            border-collapse: collapse;
            text-align: center;
            /*table-layout: fixed;*/
            th {
                border: 1px solid #ebeef5;
                padding: 0;
                margin: 0;
                height: 44px;
                border-spacing: 0;
                border-collapse: collapse;
                color: #909399;
            }
            td {
                padding: 0px 8px;
                margin: 0;
                height: 44px;
                border-collapse: collapse;
                border-spacing:0;
                border:1px solid #ebeef5;
            }
        }
    }
    .el-card__header{
        &>div{
            position: relative;
        }
    }
    .refresh{
        position: absolute;
        top: 12px;
        right: 2px;
        width: 100px;
        height: 30px;
        line-height: 30px;
        color: #ffffff;
        background-color: #1890ff;
        text-align: center;
        cursor: pointer;
    }


</style>
